
import Pusher from 'pusher-js';

// Enable pusher logging - don't include this in production
// Pusher.logToConsole = true;


import Constants from 'expo-constants'
import api from './api'


const pusher = new Pusher(Constants.expoConfig?.extra?.PUSHER_KEY, {
    cluster: Constants.expoConfig?.extra?.PUSHER_CLUSTER,
    authorizer: function (channel, options) {
        return {
            authorize: function (socketId, callback) {
                api.post('/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name,
                })
                    .then(response => {
                        callback(false, response.data)
                    })
                    .catch(error => {
                        console.error("Pusher Auth error", error)
                    })
            }
        };
    }

    // Deprecated
    // authEndpoint: `${extra.apiUrl}broadcasting/auth`,
    // auth: {
    //     headers: {
    //         "Authorization": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NDNlOGQzNy1kMzk4LTQwMzYtOTk5YS0yODA4OTAzMTZkYWMiLCJqdGkiOiI3MjU3ZGU5Y2VmZDcxZGU1NjNmZjhmMTI1NTU4MGRlYmMxYWRiYTUzNTBiYWIwZTZhZWFlODEwN2ZmYjA2MDU2MTQ3NDY4ZWFmNTRkZDA5ZiIsImlhdCI6MTYzMDU1NjI2OSwibmJmIjoxNjMwNTU2MjY5LCJleHAiOjE2NjIwOTIyNjksInN1YiI6IjEiLCJzY29wZXMiOltdfQ.bznjYBwim-V286GnIRr-Ims3mY0LTQCgejmy1JwVK0B7E_--R2b6EG7us7zDCJtpDQLIMD1zrpTywxfYBC50yWBHuEwVwwRvTXl98QQ6_3HjkHo6CmSJk03XBdAHkCoy7l6ppitM8Zh_e_BhPqxZdcJBn97AugqqGMVywnMSu4COFqHnjA_Utsqw-c2OYyHBcK1aQ7I0bfuOXBsUCj5bO9Pv9dxfWCyQOY0R5FN-Q699BhwezB-zPXU1WWx7z93E0DUDAUkXy9wdXzj3Dob7RPZUE2vn5RrJvVBOl8r0SFuboVb2BuxsKi0dXOdNwCGuxyQuUIqh7xUmBArjF99FQ-E-2sYckxsGCVgbled9ybisI7ck-KONZZA17hYU7EsCSBqwCS1mcuGLOtDwLGK7MqGhmoOJo1zKcRGI4ba6sSLpDFHwFo2iQA23UYKZW-hzaibn2gSAe929JoAUeCcSsk_QxLGAEBYroWJXTI3LnwOTeDif0vzdRGTe2dh32--QJ4WEriNpr_qTcx7UlZDibg1ujuC74eJ2fQq97oJZEopr6TQaPKoI9IcKJ253hJKTxp0ReI4NfDMtQy6gsey3Mnv_g4vcj5Dj1Y95U0lrlZDTk5a4JyB2Raf6muZHIEbr9djXDEde1I9msEwcxbytrn8QcvBkWAfc2hXBnR1jYaU",
    //         "Accept": "application/json",
    //     },
    // },
});

export default pusher